/**
 * Role model shared by apps/auction and apps/admin (extracted from
 * apps/auction/src/features/clients/types/user.ts `User['role']` +
 * shared/utils CarFinderUtils.hasPermission).
 *
 * Roles are open strings in the database; ADMIN_ROLE is the only value with
 * hard-coded semantics across the platform (web session checks, api-node
 * RolesGuard, nav filtering).
 */
/** The privileged role checked across web, admin, and api-node. */
export const ADMIN_ROLE = 'admin';
/**
 * The owner-level role (owner decision 2026-10-13). Gates the admin sections
 * that change the platform itself rather than serve a client: feed keys,
 * maintenance settings, tariffs and marketplace moderation.
 *
 * It is ADDITIVE, never a replacement: a superuser also holds `admin`
 * (`users.role` = `['admin', 'local_owner', 'superadmin']`), so every
 * `admin` check keeps working unchanged and the superadmin gates are an extra
 * requirement on top of it. Roles are an array — check with `hasPermission` /
 * `includes`, never `role === 'superadmin'` or `role[0]`.
 */
export const SUPERADMIN_ROLE = 'superadmin';
//# sourceMappingURL=roles.js.map